import React, { useCallback, useState } from 'react';

export const withInputClearableOnCloseOnly = C => ({ onInputChange: onInputChangeProp, clearInputOnSelect, ...props }) => {
  const [inputValue, setInputValue] = useState('');
  const onInputChange = useCallback((val, context) => {
    if (context.action !== 'set-value' || clearInputOnSelect) {
      setInputValue(val);
      if (typeof onInputChangeProp === 'function') {
        onInputChangeProp(val, context);
      }
    }
  }, [onInputChangeProp, clearInputOnSelect]);

  return <C onInputChange={onInputChange} inputValue={inputValue} {...props}/>;
};
